import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "upload", "editor"]

  connect() {
    this.toggle()
  }

  toggle() {
    const generated = this.sourceTarget.value === "generated"
    this.uploadTarget.hidden = generated
    this.editorTarget.hidden = !generated
    this.uploadTarget.querySelectorAll("input").forEach(input => { input.disabled = generated })
    this.editorTarget.querySelectorAll('input[type="hidden"]').forEach(input => { input.disabled = !generated })
  }
}
